import {ImportReadiness} from 'common/helpers/csvImportReadiness'
import React from 'react'
import {Alert} from 'react-bootstrap'

interface ImportReadinessPanelProps {
  importReadiness: ImportReadiness | null
  className?: string
}

const ImportReadinessPanel: React.FC<ImportReadinessPanelProps> = ({
  importReadiness,
  className = 'mb-4',
}) => {
  if (!importReadiness) {
    return null
  }

  const isBlocked = importReadiness.canProceed === false
  const warningMessage =
    importReadiness.warningMessage ||
    (importReadiness.warnings ?? [])
      .map((item) => item.issue ?? item.error ?? item.message)
      .filter(Boolean)
      .join('. ')

  if (!isBlocked && !warningMessage) {
    return null
  }

  const summaryMessage =
    importReadiness.summaryMessage ||
    'Please complete all required data in the Excel file before continuing.'

  return (
    <div className={className}>
      {isBlocked && (
        <Alert variant='danger' className='mb-0'>
          <Alert.Heading className='h5 mb-2'>
            <i className='fas fa-exclamation-triangle me-2' />
            File validation failed
          </Alert.Heading>
          <p className='mb-0'>{summaryMessage}</p>
        </Alert>
      )}

      {/* Shown alongside an enabled Import button — the choice is the user's. */}
      {Boolean(warningMessage) && (
        <Alert
          variant='warning'
          className={
            isBlocked ? 'mb-0 mt-3 csv-import-warning-alert' : 'mb-0 csv-import-warning-alert'
          }
        >
          <Alert.Heading className='h5 mb-2'>
            <i className='fas fa-exclamation-triangle me-2' />
            Some rows need attention
          </Alert.Heading>
          <p className='mb-1'>{warningMessage}</p>
          <p className='mb-0 small'>
            You can still import. Affected rows are saved without the missing link, and the import
            summary lists every one of them.
          </p>
        </Alert>
      )}
    </div>
  )
}

export default ImportReadinessPanel
